function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReceiptPlaceholderPlus = function SvgReceiptPlaceholderPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.268 6.268 0 14 0s14 6.268 14 14-6.268 14-14 14S0 21.732 0 14Z",
    style: {
      fill: "#03d47c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2 18.2a1.2 1.2 0 1 1-2.4 0v-3h-3a1.2 1.2 0 1 1 0-2.4h3v-3a1.2 1.2 0 1 1 2.4 0v3h3a1.2 1.2 0 1 1 0 2.4h-3v3Z",
    style: {
      fill: "#fcfbf9"
    }
  }));
};
export default SvgReceiptPlaceholderPlus;